var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4024 14.9597L11.7545 10.3118C12.636 9.22343 13.1667 7.8398 13.1667 6.33336C13.1667 2.84116 10.3255 0 6.83333 0C3.34113 0 0.5 2.84116 0.5 6.33336C0.5 9.82556 3.34116 12.6667 6.83336 12.6667C8.3398 12.6667 9.72343 12.136 10.8118 11.2545L15.4597 15.9024C15.5899 16.0325 15.8009 16.0325 15.9311 15.9024L16.4024 15.4311C16.5325 15.3009 16.5325 15.0898 16.4024 14.9597ZM6.83336 11.3334C4.0762 11.3334 1.83335 9.09052 1.83335 6.33336C1.83335 3.5762 4.0762 1.33335 6.83336 1.33335C9.59052 1.33335 11.8334 3.5762 11.8334 6.33336C11.8334 9.09052 9.59052 11.3334 6.83336 11.3334Z",
    fill: "rgba(0, 0, 0, 0.2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6db10ff11ce0439689dd26eac90ca8e5.svg";
export { ForwardRef as ReactComponent };